import React from "react";

import {Container, withStyles} from "@material-ui/core";
import {SelectableInstrumentsTable} from "../../../../../../../../../../../../components/SelectForProductsComparisonModal/SelectForProductsComparisonModal";
import {musterPortfolioInstrumentsTableStructure} from "../../../../../../../../../../../Modelportfolios/components/InstrumentsList/table-data";

import styles from "./styles";


const ModelportfolioInstrumentsSelection = (props) => {
  const {
    classes,
    portfolio,
  } = props;

  const handleAllSelected = () => {
    if (props.onSelectAll){
      const selected = props.selectedInstruments || [];
      let assets = (portfolio.assets || []).filter(asset => !asset.disabledByFilter);
      if (selected.length === assets.length) {
        assets = []; // unselect all
      }

      props.onSelectAll(assets)
    }
  };

  return (
    <Container style={{paddingBottom: 16}}>
      <SelectableInstrumentsTable
        container={portfolio || {}}
        ContainerProps={{
          enabled: true,
          path: 'MODELPORTFOLIO_OVERVIEW',
          selectable: !!props.onSourceSelect,
          checked: props.sourceSelected,
          onChange: props.onSourceSelect,
          classes: {
            containerName: classes.containerName,
            containerCheckbox: classes.containerCheckbox
          }
        }}
        instruments={portfolio.assets || []}
        InstrumentsProps={{
          enabled: true,
          selected: props.selectedInstruments || [],
          handleSelectAll: !!props.onSelectAll ? handleAllSelected : null,
          handleSelect: props.onInstrumentSelect,
          tableStructure: musterPortfolioInstrumentsTableStructure,
          tableClasses: classes
        }}
      />
    </Container>
  );
};

export default withStyles(styles)(ModelportfolioInstrumentsSelection);